interface UserParams {
  userId: string;
}
export class User {
  userId?: string;

  constructor(params?: UserParams) {
    this.userId = params?.userId;
  }

  setUserId(userId: string) {
    this.userId = userId;
  }

  clearUser() {
    this.userId = undefined;
  }
}
